import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { APP_SETTINGS } from '../models/backofficeConfiguration';
import { ExecuteService } from './executeService.service';
import { ErrorHandlerService } from './errorHandler.service';
import { CalendarEventDate } from '../models/calendarEventDate';


@Injectable()
export class CalendarService {

  constructor(private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) {
  }

  public getEventDateById(eventDateId: string, locale: string): Observable<CalendarEventDate> {
    const requestUrl = `${APP_SETTINGS.CalendarI3ApiUrl}${locale}/api/v1/eventDates/${eventDateId}`;
    return this.executeService.ExecuteWithApiToken('get', requestUrl)
      .pipe(
        catchError((error: any): any => {
          let ignoreNotFound = false;
          if (error.status === 404) {
            ignoreNotFound = true;
          }
          return this.errorHandler.handleError<object[]>('CalendarService_EventDate_ById', null, ignoreNotFound);
        }));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/calendar.service.ts